import { render } from "./systemManagement.vue?vue&type=template&id=3ebaeec7"
import script from "./systemManagement.vue?vue&type=script&lang=js"
export * from "./systemManagement.vue?vue&type=script&lang=js"

import "./systemManagement.vue?vue&type=style&index=0&id=3ebaeec7&lang=less"
script.render = render

export default script